import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=a4cb7a3c&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=ts"
export * from "./Dev.vue?vue&type=script&lang=ts"
import style0 from "./Dev.vue?vue&type=style&index=0&id=a4cb7a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cb7a3c",
  null
  
)

export default component.exports